// extracted by css-extract-rspack-plugin
export default {"wrapperForm":"dAZbnoF7JxM_cwqq","editBtn":"qK3LzYltzgDFJ2TF"};